module.exports = __webpack_public_path__ + "static/media/FAQ-lost-card.0907e12e.svg";